// Other Branches
export const GET_OTHER_BRANCHES_START = 'GET_OTHER_BRANCHES_START';
export const GET_OTHER_BRANCHES_SUCCESS = 'GET_OTHER_BRANCHES_SUCCESS';
export const GET_OTHER_BRANCHES_FAIL = 'GET_OTHER_BRANCHES_FAIL';

// More Like This
export const GET_MORE_LIKE_THIS_START = 'GET_MORE_LIKE_THIS_START';
export const GET_MORE_LIKE_THIS_SUCCESS = 'GET_MORE_LIKE_THIS_SUCCESS';
export const GET_MORE_LIKE_THIS_FAIL = 'GET_MORE_LIKE_THIS_FAIL';
